import React from 'react';
import {MantineProvider} from '@mantine/core';
import {Notifications} from '@mantine/notifications';
import {ModalsProvider} from '@mantine/modals';

import Navigation from 'config/navigation';
import GlobalStyle from 'config/style';
import {I18nextProvider} from 'react-i18next';
import i18n from './config/i18next';
import {QueryClient, QueryClientProvider} from 'react-query';
import {GoogleOAuthProvider} from '@react-oauth/google';
import {lightColors, darkColors} from 'shared/assets/colors';
import {ThemeProvider} from 'styled-components';

const queryClient = new QueryClient();

const App: React.FC = () => {
  const theme = localStorage.getItem('theme') as 'dark' | 'light';
  const colors = theme === 'dark' ? darkColors : lightColors;

  return (
    <QueryClientProvider client={queryClient}>
      <MantineProvider defaultColorScheme={theme ?? 'light'}>
        <ThemeProvider {...{theme: {colors}}}>
          <I18nextProvider i18n={i18n}>
            <ModalsProvider>
              <Notifications
                position="bottom-right"
                autoClose={1000 * 20}
                zIndex={10 * 5000}
              />
              <GoogleOAuthProvider clientId="974725828738-66bvun69tnvadq99b6oi7jfi34j4hjq7.apps.googleusercontent.com">
                <Navigation />
              </GoogleOAuthProvider>
            </ModalsProvider>
          </I18nextProvider>
          <GlobalStyle />
        </ThemeProvider>
      </MantineProvider>
    </QueryClientProvider>
  );
};

export default App;
